"use client";

import { identity } from "deso-protocol";
import { use, useEffect, useState } from "react";

import { countPageView } from "@/backend/focus";
import { createToastErrorDetails } from "@/components/ui/toast-helpers";
import { useToast } from "@/components/ui/use-toast";
import { UserContext } from "@/contexts/user-context";

interface PageViewsTrackerProps {
  route: string;
  params: Array<string>;
}

const PageViewsTracker = ({ route, params }: PageViewsTrackerProps) => {
  const { currentUserPublicKey } = use(UserContext);
  const { toast } = useToast();
  const [tracked, setTracked] = useState(false);

  useEffect(() => {
    const run = async () => {
      const { host } = window.location;

      if (tracked) return;

      try {
        if (currentUserPublicKey) {
          const jwt = await identity.jwt();
          await countPageView(host, route, params, currentUserPublicKey, jwt);
        } else {
          await countPageView(host, route, params);
        }
        setTracked(true);
      } catch (e) {
        toast({
          variant: "destructive",
          title: "Error",
          description: `An error happened when counting page view`,
          details: createToastErrorDetails(e),
        });
      }
    };

    run();
  }, [params, currentUserPublicKey, route, toast, tracked]);

  return <></>;
};

export default PageViewsTracker;
